import React, { Component } from 'react';
import { Modal, Form, FormGroup, FormControl, ControlLabel, Col, Panel } from 'react-bootstrap';
import Button from '../common/form/button';
// import Select from '../common/form/selectSemGrid'; // Se precisar de selects customizados
import { toastr } from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createTicket, updateTicket } from './ticketSuporteActions';
import { getConfControladorGrupoList } from '../common/selectdb/selectdbAtions'; // Importar a action
// import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
// import SelectConfControlador from '../common/selectdb/selectConfControlador';
import SelectGrupoFisicoParaTicket from '../common/selectdb/SelectGrupoFisicoParaTicket';
import SelectControladorParaTicket from '../common/selectdb/SelectControladorParaTicket';

// Estilos para os painéis
const panelStyle = {
  marginBottom: '20px',
  border: '1px solid #ddd',
  borderRadius: '4px',
  boxShadow: 'none',
};

const panelHeadingStyle = {
  padding: '10px 15px',
  borderBottom: '1px solid transparent',
  borderTopLeftRadius: '3px',
  borderTopRightRadius: '3px',
};

const panelBodyStyle = {
  padding: '15px',
};

class TicketSuporteForm extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(this.props.ticket);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGrupoFisicoChange = this.handleGrupoFisicoChange.bind(this);
    this.handleControladorChange = this.handleControladorChange.bind(this);
  }

  getInitialState(ticket = null) {
    if (ticket) {
      return {
        id: ticket.id || null,
        titulo: ticket.titulo || '',
        descricao: ticket.descricao || '',
        status: ticket.status || 'ABERTO',
        controlador_id: ticket.controlador_id || '',
        grupo_fisico_id: ticket.grupo_fisico_id || '',
        numero_controlador: ticket.numero_controlador || null,
        controlador_erro_id: ticket.controlador_erro_id || null,
        isFromError: ticket.isFromError || false,
      };
    }
    return {
      id: null,
      titulo: '',
      descricao: '',
      status: 'ABERTO',
      controlador_id: '',
      grupo_fisico_id: '',
      numero_controlador: null,
      controlador_erro_id: null,
      isFromError: false,
    };
  }

  componentDidMount() {
    if (this.state.isFromError && this.state.grupo_fisico_id) {
      this.props.getConfControladorGrupoList(this.state.grupo_fisico_id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.listConf !== prevProps.listConf && this.props.listConf.length > 0 && this.state.isFromError) {
      this.findAndSetControllerId(this.props.listConf);
    }
  }

  findAndSetControllerId(controllerList) {
    const targetNumero = parseInt(this.state.numero_controlador, 10);
    let foundController = controllerList.find(
      c => parseInt(c.numero_controlador, 10) === targetNumero && parseInt(c.anel, 10) === 1,
    );
    if (!foundController) {
      foundController = controllerList.find(c => parseInt(c.numero_controlador, 10) === targetNumero);
    }
    if (foundController && this.state.controlador_id !== foundController.id) {
      this.setState({ controlador_id: foundController.id });
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleGrupoFisicoChange(grupoId) {
    this.setState({ grupo_fisico_id: grupoId || '', controlador_id: '' });
  }

  handleControladorChange(controladorId) {
    this.setState({ controlador_id: controladorId || '' });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { id, titulo, descricao, status, controlador_id, grupo_fisico_id, controlador_erro_id } = this.state;

    if (this.state.isFromError && !controlador_id) {
      toastr.warning('Aguarde', 'Ainda estamos identificando o controlador, tente salvar novamente em um segundo.');
      return;
    }

    const ticketData = { id, titulo, descricao, status, controlador_id, grupo_fisico_id, controlador_erro_id };

    const promise = ticketData.id ? this.props.updateTicket(ticketData) : this.props.createTicket(ticketData);
    promise
      .then(() => {
        toastr.success('Sucesso', `Ticket ${ticketData.id ? 'atualizado' : 'criado'} com sucesso.`);
        this.props.onHide();
      })
      .catch(error => {
        toastr.error('Erro', 'Falha ao salvar ticket.');
        console.error('Erro ao salvar ticket:', error);
      });
  }

  render() {
    const { show, onHide, ticket } = this.props;
    const { titulo, descricao, status, controlador_id, grupo_fisico_id, isFromError, numero_controlador } = this.state;
    const isEditing = !!(ticket && ticket.id);
    const isPreLinkedToError = isEditing && ticket && ticket.controlador_id && ticket.erro_controlador_momento_abertura;

    return (
      <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} bsSize="large">
        <Modal.Header closeButton style={{ backgroundColor: '#3c8dbc', color: 'white', borderBottom: 'none' }}>
          <Modal.Title>{isEditing ? 'Editar Ticket' : 'Novo Ticket de Suporte'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px 25px 5px 25px' }}>
          <Form horizontal onSubmit={this.handleSubmit}>
            {isPreLinkedToError && (
              <Panel bsStyle="info" defaultExpanded style={{ marginBottom: '15px' }}>
                <Panel.Heading>
                  <Panel.Title toggle>Informações do Erro Vinculado</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible style={{ padding: '15px 15px 5px 15px' }}>
                  <FormGroup controlId="formInfoControladorLinked" style={{ marginBottom: '10px' }}>
                    <Col componentClass={ControlLabel} sm={3}>
                      Controlador ID:
                    </Col>
                    <Col sm={9}>
                      <FormControl.Static>
                        {ticket && ticket.controlador_id ? ticket.controlador_id : controlador_id || 'N/A'}
                      </FormControl.Static>
                    </Col>
                  </FormGroup>
                  <FormGroup style={{ marginBottom: '10px' }}>
                    <Col componentClass={ControlLabel} sm={3}>
                      Detalhes do Erro:
                    </Col>
                    <Col sm={9}>
                      <FormControl.Static>
                        {(ticket && ticket.erro_controlador_momento_abertura) || 'N/A'}
                      </FormControl.Static>
                    </Col>
                  </FormGroup>
                </Panel.Body>
              </Panel>
            )}

            {isFromError && !isEditing && (
              <Panel bsStyle="info" defaultExpanded>
                <Panel.Heading>
                  <Panel.Title>Vinculado ao Erro do Controlador</Panel.Title>
                </Panel.Heading>
                <Panel.Body style={{ padding: '15px' }}>
                  <FormGroup style={{ marginBottom: '5px' }}>
                    <Col componentClass={ControlLabel} sm={3}>
                      Grupo Físico:
                    </Col>
                    <Col sm={9}>
                      <FormControl.Static>{grupo_fisico_id}</FormControl.Static>
                    </Col>
                  </FormGroup>
                  <FormGroup style={{ marginBottom: '5px' }}>
                    <Col componentClass={ControlLabel} sm={3}>
                      Controlador:
                    </Col>
                    <Col sm={9}>
                      <FormControl.Static>{numero_controlador}</FormControl.Static>
                    </Col>
                  </FormGroup>
                </Panel.Body>
              </Panel>
            )}

            <Panel bsStyle="primary" defaultExpanded style={{ marginBottom: '15px' }}>
              <Panel.Heading>
                <Panel.Title toggle>Detalhes do Ticket</Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible style={{ padding: '15px 15px 5px 15px' }}>
                <FormGroup controlId="formTitulo" style={{ marginBottom: '10px' }}>
                  <Col componentClass={ControlLabel} sm={2}>
                    Título
                  </Col>
                  <Col sm={10}>
                    <FormControl
                      type="text"
                      name="titulo"
                      value={titulo}
                      onChange={this.handleChange}
                      required
                      maxLength={255}
                      placeholder="Um breve resumo do problema ou solicitação"
                    />
                  </Col>
                </FormGroup>

                <FormGroup controlId="formDescricao" style={{ marginBottom: '10px' }}>
                  <Col componentClass={ControlLabel} sm={2}>
                    Descrição
                  </Col>
                  <Col sm={10}>
                    <FormControl
                      componentClass="textarea"
                      name="descricao"
                      value={descricao}
                      onChange={this.handleChange}
                      rows={4}
                      placeholder="Detalhe o problema, passos para reproduzir, ou a solicitação completa."
                    />
                  </Col>
                </FormGroup>
              </Panel.Body>
            </Panel>

            {!isFromError && !isPreLinkedToError && (
              <Panel bsStyle="default" defaultExpanded={!isPreLinkedToError} style={{ marginBottom: '15px' }}>
                <Panel.Heading>
                  <Panel.Title toggle>Vincular a um Controlador (Opcional)</Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible style={{ padding: '15px 15px 0px 15px' }}>
                  <FormGroup controlId="formSelectGrupoFisicoCtrlExt" style={{ marginBottom: '15px' }}>
                    <Col sm={10} md={5}>
                      <SelectGrupoFisicoParaTicket onChange={this.handleGrupoFisicoChange} value={grupo_fisico_id} />
                    </Col>
                  </FormGroup>
                  <FormGroup controlId="formSelectControladorCtrlExt" style={{ marginBottom: '5px' }}>
                    <Col sm={10} md={5}>
                      <SelectControladorParaTicket
                        anel={false}
                        onChange={this.handleControladorChange}
                        value={controlador_id}
                        grupoFisicoId={grupo_fisico_id}
                      />
                    </Col>
                  </FormGroup>
                </Panel.Body>
              </Panel>
            )}

            <Panel bsStyle="default" defaultExpanded style={{ marginBottom: '15px' }}>
              <Panel.Heading>
                <Panel.Title toggle>Status</Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible style={{ padding: '15px 15px 5px 15px' }}>
                <FormGroup controlId="formStatus" style={{ marginBottom: '10px' }}>
                  <Col componentClass={ControlLabel} sm={2}>
                    Status
                  </Col>
                  <Col sm={4}>
                    <FormControl
                      componentClass="select"
                      name="status"
                      value={status}
                      onChange={this.handleChange}
                      disabled={!isEditing}
                    >
                      <option value="ABERTO">Aberto</option>
                      <option value="EM_ANDAMENTO">Em Andamento</option>
                      <option value="FINALIZADO">Finalizado</option>
                    </FormControl>
                  </Col>
                </FormGroup>
              </Panel.Body>
            </Panel>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ padding: '15px 25px', textAlign: 'right', borderTop: '1px solid #e5e5e5' }}>
          <Button className="btn btn-default" onClick={onHide} label="Cancelar" style={{ marginRight: '10px' }} />
          <Button
            className="btn btn-primary"
            icon="save"
            onClick={this.handleSubmit}
            label={isEditing ? 'Salvar Alterações' : 'Criar Ticket'}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  listConf: state.controladorCad.listConf,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createTicket, updateTicket, getConfControladorGrupoList }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TicketSuporteForm);
